import styles from "./style.module.scss"

import React from "react"

import type { ExtraParams } from "../../index-type"

import LoadingIcon from "@/components/loadingIcon"
import { Button } from "@mui/material"

import ImageErrorIcon from "@/components/previewResource/icons/imageErrorIcon.svg"

import { useTranslation } from "@/i18n/client"

interface PropsType {
  isLoading: boolean;
  isError: boolean;
  extraParams?: ExtraParams;
  tryAgainHandler: () => void;
}

const ResourceLoadError: React.FC<PropsType> = ({
  isLoading,
  isError,
  extraParams = {},
  tryAgainHandler
}) => {
  const { t } = useTranslation()

  return (
    <>
      {isLoading &&
        <div className={styles.loading}>
          <LoadingIcon sizes={50} />
        </div>
      }

      {isError &&
        <div className={styles.error_box}>
          <ImageErrorIcon />

          <span>{t('previewResource.loadErrorDesc')}</span>

          <Button
            {...extraParams}
            size="small"
            variant="outlined"
            sx={{
              color: "#fff",
              borderColor: "#fff",
            }}
            onClick={tryAgainHandler}>{t('common.btnText.tryAgain')}</Button>
        </div>
      }
    </>
  )
}

export default ResourceLoadError